import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useUserInfo } from '@/utils/swr';
import { userSession } from '@/utils/userSession';
import { useStore } from '@/utils/vue';

const TARGET_ROUTES = ['anewsHome', 'themeFeed'];

export const useTranslateNotification = () => {
  const store = useStore();
  const route = useRoute();
  const { data: userInfo } = useUserInfo();

  const feedType = computed(() => store.state.feedType.feedType);
  const isOpen = ref(false);

  const showTranslateNotification = (): void => {
    if (
      feedType.value === 'foreign' &&
      TARGET_ROUTES.includes(route.name as string) &&
      !userSession.getIsShownTranslateNotification()
    ) {
      isOpen.value = true;
    }
  };

  const stopUserInfoWatch = watch(userInfo, u => {
    if (!u) return;

    showTranslateNotification();
    stopUserInfoWatch();
  });

  watch(() => [feedType.value, route.name], showTranslateNotification);

  const close = () => {
    isOpen.value = false;
  };

  return { isOpen, close };
};
